import { fetchApiData, interpolate } from '../../Utils/ApiCalls';
import { LIST_CREATE_COMPANY_PLAN_ROOMS_ENDPOINT, UPDATE_DELETE_PLAN_ROOM_ENDPOINT } from '../../urls';

export const PLANROOMS_PER_PAGE = 20;

export const parsePlanrooms = data => {
  const raw = Array.isArray(data) ? data : data?.results || [];
  return raw.map(item => ({
    id: item?.id ?? '',
    companyId: item?.company_id || '',
    name: item?.name || '',
    url: item?.login_url || item?.url || '',
    username: item?.user_name || item?.account_id || '',
    password: item?.password || item?.account_password || ''
  }));
};

export const planroomsCount = data => {
  if (Array.isArray(data)) return data.length;
  const count = Number(data?.count);
  return Number.isFinite(count) ? count : parsePlanrooms(data).length;
};

export const listPlanrooms = ({ companyId, page = 1, perPage = PLANROOMS_PER_PAGE, signal } = {}) =>
  fetchApiData({
    endpoint: interpolate(LIST_CREATE_COMPANY_PLAN_ROOMS_ENDPOINT, [encodeURIComponent(companyId)]),
    apiRequest: 'GET',
    params: {
      page,
      per_page: perPage
    },
    signal
  });

const planroomPayload = ({ name, url, username, password }) => ({
  name,
  login_url: url,
  user_name: username,
  password
});

export const createPlanroom = ({ companyId, name, url, username, password }) =>
  fetchApiData({
    endpoint: interpolate(LIST_CREATE_COMPANY_PLAN_ROOMS_ENDPOINT, [encodeURIComponent(companyId)]),
    apiRequest: 'POST',
    data: planroomPayload({ name, url, username, password })
  });

export const updatePlanroom = ({ planroomId, name, url, username, password }) =>
  fetchApiData({
    endpoint: interpolate(UPDATE_DELETE_PLAN_ROOM_ENDPOINT, [encodeURIComponent(planroomId)]),
    apiRequest: 'PATCH',
    data: planroomPayload({ name, url, username, password })
  });

export const deletePlanroom = ({ planroomId }) =>
  fetchApiData({
    endpoint: interpolate(UPDATE_DELETE_PLAN_ROOM_ENDPOINT, [encodeURIComponent(planroomId)]),
    apiRequest: 'DELETE'
  });
